import React, {forwardRef, useImperativeHandle, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'antd';

import TaskResultInfo from "@/page/admin/JobsPage/TaskResultPage/TaskResultInfo";

const TaskResultInfoModal = forwardRef(({modalTitle}, ref) => {

    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);

    function showModal(id) {
        setVisible(true);
        setId(id);
    }

    function closeModal() {
        setVisible(false);
        setId(null);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));


    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            width={680}
            title={modalTitle}
            visible={visible}
            onCancel={closeModal}
            onOk={closeModal}
        >
            <TaskResultInfo id={id} />
        </Modal>
    );
});

TaskResultInfoModal.displayName = 'TaskResultInfoModal';

TaskResultInfoModal.propTypes = {
    modalTitle: PropTypes.string,
};

export default TaskResultInfoModal;
